module.exports = __webpack_public_path__ + "static/img/party02.7ba6fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liquor/party02.png
// module id = C7oX
// module chunks = 21